import { Spin } from "antd";
import { get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { CURRENCY_SYMBOL, TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import cartBagIcon from "../../../../Assets/icons/cart_bag.svg";
import CartModal from "./Modal";

function Cart({ project, generalCost, updateStatus, loading, upsells = [] }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("NAVBAR", { returnObjects: true });
  const [open, setOpen] = useState(false);
  const totalAmount = upsells
    .reduce((acc, { cost }) => (acc += cost), get(generalCost, "cost", 0))
    .toFixed(2);
  const onSubmit = () => {
    updateStatus({
      template: TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_ACORIS].PRODUCTS,
    });
  };

  const onClose = () => setOpen(false);

  const onOpen = () => setOpen(true);

  return (
    <>
      <button type="button" className="acoris-navbar__cart" onClick={onOpen}>
        {loading ? (
          <Spin size="small" />
        ) : (
          <>
            <img
              src={cartBagIcon}
              alt=""
              className="acoris-navbar__cart-icon"
            />
            <span className="acoris-navbar__cart-amount">
              <span className="acoris-navbar__cart-price">
                {`${costToFrench(totalAmount)} ${
                  CURRENCY_SYMBOL[generalCost?.currency] || "€"
                }`}
              </span>
              <span className="acoris-navbar__cart-period">
                {TRANSLATION?.PER_MONTH || "/mois"}
              </span>
            </span>
          </>
        )}
      </button>
      <CartModal
        open={open}
        onSubmit={onSubmit}
        onClose={onClose}
        generalCost={generalCost}
        upsells={upsells}
      />
    </>
  );
}

export default Cart;
